import { Controller } from "@hotwired/stimulus";

// Live-previews the file chosen in a file input by swapping the background
// image of the preview element. Used on the inventory-catalog form so a user
// copying a catalog can see that the source image will be used unless they
// upload a replacement.
export default class extends Controller {
  static targets = ["input", "image", "label"];

  preview() {
    const file = this.inputTarget.files?.[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    this.imageTarget.style.backgroundImage = `url('${url}')`;
    this.imageTarget.classList.remove("d-none");

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = "New image to be uploaded:";
      this.labelTarget.classList.remove("d-none");
    }
  }
}
